
import Tag from "antd/es/tag";
import Row from "antd/es/row";
import Space from "antd/es/space";
import Descriptions from "antd/es/descriptions";


import { ResponseType } from "pages/tasks";
import * as api from "components/api";
import { ILookup } from "components/api";
import { PageHeader } from "@ant-design/pro-layout";
import { ProCard } from '@ant-design/pro-components';
import ActionMenu from "./action_menu";
import { Progress } from "antd/lib";
import { convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { useEffect, useState } from "react";

type profileHeaderProps = {
  data: ResponseType;
  options: Record<api.ILookupKeys, api.ICombo[]>;
  title: string;
};

export const ProfileHeader = ({
  data,
  title,
  options,
}: profileHeaderProps) => {
  const [description, setDescription] = useState('');
  useEffect(() => {
    if (data.description) {
      try {
        const descriptionStateContent = convertFromRaw(JSON.parse(data.description));
        setDescription(convertToHTML(descriptionStateContent));
      }
      catch (error) {
        setDescription(data.description);
      };
    }
  }, []);

  return (
    <PageHeader
      onBack={() => window.history.back()}
      title={title}
      subTitle={`${data.title}`}
      tags={
        <Space>
          <Tag color={data.active ? "green" : "volcano"}>
            Active: {data.active ? "Yes" : "No"}
          </Tag>
          <Tag color={data.status.name === "Completed" ? "green" : "volcano"}>
            Status: {data.status.name}
          </Tag>


        </Space>

      }
    // extra={
    //   <Space>
    //     <ActionMenu
    //       handleClick={handler}
    //       active={data.active}
    //       canAccess={data.hasUser}
    //     />
    //   </Space>
    // }
    >

      <ProCard
        title="Task Detail"
        split={'vertical'}
        bordered
        headerBordered
      >
        <ProCard colSpan="50%">



          <Descriptions size="default" column={1}>
            <Descriptions.Item label="Title">
              {data.title}
            </Descriptions.Item>
            <Descriptions.Item label="Deliverables">
              {data.deliverables}
            </Descriptions.Item>
            <Descriptions.Item label="Date">{data.date}</Descriptions.Item>
            <Descriptions.Item label="Target Completed Date">{data.targetCompletedDate}</Descriptions.Item>
            <Descriptions.Item label="Status">
              {data.status.name}
            </Descriptions.Item>
            <Descriptions.Item label="Percentage" >
              <Progress percent={data.percentage} style={{ width: "50%" }} />
            </Descriptions.Item>

          </Descriptions>

        </ProCard>
        <ProCard >

          <Descriptions size="default" column={1}>
            <Descriptions.Item label="Responsible manager">
              {data.responsibleManager}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {data.responsibleManager}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {data.employee.value}
            </Descriptions.Item>
            <Descriptions.Item label="Company">
              {data.company.name}
            </Descriptions.Item>
            <Descriptions.Item label="Department">{data.department.name}</Descriptions.Item>
            <Descriptions.Item label="Deliverables">{data.deliverables}</Descriptions.Item>
            <Descriptions.Item label="Priority" >
              {data.priority.name}
            </Descriptions.Item>

            <Descriptions.Item label="Action Points" >
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Descriptions.Item>
          </Descriptions>
        </ProCard>
      </ProCard>
    </PageHeader>
  );
};
